import { render, staticRenderFns } from "./UpdateDepartment.vue?vue&type=template&id=1373e09c&scoped=true"
import script from "./UpdateDepartment.vue?vue&type=script&lang=js"
export * from "./UpdateDepartment.vue?vue&type=script&lang=js"
import style0 from "./UpdateDepartment.vue?vue&type=style&index=0&id=1373e09c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373e09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1373e09c')) {
      api.createRecord('1373e09c', component.options)
    } else {
      api.reload('1373e09c', component.options)
    }
    module.hot.accept("./UpdateDepartment.vue?vue&type=template&id=1373e09c&scoped=true", function () {
      api.rerender('1373e09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/UpdateDepartment.vue"
export default component.exports